import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export async function getClubs() {
	return new Promise<ltFramework.IClub[]>((resolve) => {
		const check = () => {
			const clubsStore = window.ef.clubsStore.getInitialData();
			if (clubsStore.initialized) {
				resolve(clubsStore.clubs);
			} else {
				setTimeout(check, 500);
			}
		};
		check();
	});
}
